import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-wizard-steps',
  templateUrl: './wizard-steps.component.html',
  styleUrls: ['./wizard-steps.component.scss'],
})
export class WizardStepsComponent {
  @Input() steps: string[] | undefined;
  @Input() activeStep: any;
}
